export const COMMUNITY_SPAM_AUTO_FLAG_THRESHOLD = 70;
export const COMMUNITY_SPAM_LINK_WEIGHT = 25;
export const COMMUNITY_SPAM_VELOCITY_WEIGHT = 30;
export const COMMUNITY_SPAM_DUPLICATE_WEIGHT = 35;

const URL_PATTERN = /https?:\/\/[^\s]+/gi;

export type CommunitySpamScoreInput = {
  content: string;
  linkCount?: number;
  postsLastHour: number;
  rateLimitPerHour: number | null | undefined;
  duplicateOfRecentPost: boolean;
};

export type CommunitySpamScoreResult = {
  score: number;
  autoFlag: boolean;
  factors: {
    links: number;
    velocity: number;
    duplicate: number;
  };
};

export function countLinksInContent(content: string): number {
  return (content.match(URL_PATTERN) ?? []).length;
}

export function scoreCommunityPostSpam(input: CommunitySpamScoreInput): CommunitySpamScoreResult {
  const links = input.linkCount ?? countLinksInContent(input.content);
  const linkScore = Math.min(COMMUNITY_SPAM_LINK_WEIGHT, links * 12);

  const rateLimit = input.rateLimitPerHour ?? 20;
  const velocityRatio = rateLimit > 0 ? input.postsLastHour / rateLimit : 0;
  const velocityScore = Math.min(
    COMMUNITY_SPAM_VELOCITY_WEIGHT,
    Math.round(velocityRatio * COMMUNITY_SPAM_VELOCITY_WEIGHT),
  );

  const duplicateScore = input.duplicateOfRecentPost ? COMMUNITY_SPAM_DUPLICATE_WEIGHT : 0;
  const score = Math.min(100, linkScore + velocityScore + duplicateScore);

  return {
    score,
    autoFlag: score >= COMMUNITY_SPAM_AUTO_FLAG_THRESHOLD,
    factors: {
      links: linkScore,
      velocity: velocityScore,
      duplicate: duplicateScore,
    },
  };
}

export function normalizeDuplicatePostContent(content: string): string {
  return content.trim().toLowerCase().replace(/\s+/g, ' ');
}
